import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

import { mockData } from "./mockData";

export const fetchProfileData = async (userId) => {
  if (!userId)
    fnThrowError({ message: `userID is required for /user/<userID>/profile2` });
  const endpoint = `/user/${userId}/profile2`;
  const response = await new FnrFetch3(endpoint).post().catch((err) => {
    fnThrowError({ message: `Error at ${endpoint}: ${err}` });
  });

  return response;
};

export const getHouseholdRelationships = async ({ userID }) => {
  const endpoint = `/user/${userID}/getHouseholdRelationships`;

  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getHouseholdRelationships)
    : new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    fnThrowError({
      message:
        err?.error ||
        `Something went wrong. Please contact help@flocknote.com for further assistance.`,
    })
  );
  return response;
};
